import React from "react";

interface Props {
  documentNumber: string;
  locked: server.dto.Locked
}

export const DocumentNumber = (props: Props) => {
  const { documentNumber: documentNumber, locked } = props;

  if (locked === "locked") {
    return <div className="flex gap">
      <div>
        <i className="icon-lock" />
      </div>
      <div>{documentNumber}</div>
    </div>;
  }

  return <div>{documentNumber}</div>;
}



